import React, { useContext } from "react";
import { BooleanField, Datagrid, List, ReferenceField, TextField } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const PartyList = (props) => {

    const context = useContext(AppContext)

    return (
        <List exporter={false} bulkActionButtons={false}
            title={'Partes'}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} fullWidth />
                <ReferenceField source="type.id" label={'Tipo'} reference="party-types">
                    <TextField source="name" />
                </ReferenceField>
                <BooleanField source="isRepresented" label={'Representado pelo NPJ'} />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
            </Datagrid>
        </List>

    )
}

export default PartyList;